<template>
  <div class="clas_stat_top">
    <div class="top-title">
      <div class="title">整体开班情况</div>
      <el-date-picker class="content-year" v-model="year" type="year" :editable="false" clearable value-format="yyyy"
        placeholder="选择年" :picker-options="filterYearOptions" @change="changeYear">
      </el-date-picker>
    </div>
    <div class="top-box flex_row-center">
      <div class="box-name mr-40"> 全部班级 </div>
      <div class="name mr-16">开班总数</div>
      <div class="num">{{ statisInfo.totalNum || 0 }}</div>
      <div class="top-box-line" />
      <div class="nam mr-16">培训总人次</div>
      <div class="num">{{ statisInfo.totalEnrollNum || 0 }}</div>
    </div>
    <div class="flex-box">
      <div class="item" v-for="(item, i) in statisInfo.classList" :key="i">
        <div class="item-name">{{ item.name }}</div>
        <div class="flex-row">
          <div class="flex-1 item-left ">
            <div class="flex_column-center">
              <div class="num">{{ item.totalNum || 0 }}</div>
              <div class="name mt-8">开班总数</div>
            </div>
          </div>
          <div class="item-center">
            <div class="flex-row">
              <div class="train-name">未开始</div>
              <div class="train-num">{{ item.notStartNum || 0 }}</div>
            </div>
            <div class="flex-row mt-8">
              <div class="train-name">培训中</div>
              <div class="train-num">{{ item.trainingNum || 0 }}</div>
            </div>
            <div class="flex-row mt-8">
              <div class="train-name">已结束</div>
              <div class="train-num">{{ item.endNum || 0 }}</div>
            </div>
          </div>
          <div class="flex-1 item-right">
            <div class="flex_column-center">
              <div class="num">{{ item.enrollNum || 0 }}</div>
              <div class="name mt-8">培训总人次</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    statisInfo: {
      type: Object,
      default: () => {
        return {
          totalNum: 0,
          totalEnrollNum: 0,
          classList: [
            { name: '网络专题培训班', totalNum: 0, notStartNum: 0, trainingNum: 0, endNum: 0, enrollNum: 0 },
            { name: '脱产培训班', totalNum: 0, notStartNum: 0, trainingNum: 0, endNum: 0, enrollNum: 0 },
            { name: '中组部选调班', totalNum: 0, notStartNum: 0, trainingNum: 0, endNum: 0, enrollNum: 0 },
          ],
        }
      },
    },
  },
  data() {
    return {
      year: '',
      filterYearOptions: {
        disabledDate: (time) => {
          const date = new Date();
          const year = date.getFullYear();
          const timeyear = time.getFullYear();
          return timeyear < 2010 || timeyear > year;
        },
      },
    };
  },
  created() { },
  activated() { },
  computed: {},
  methods: {
    changeYear() {
      this.$emit('changeYear', this.year);
    },
  },
};
</script>
<style lang="scss" scoped>
.clas_stat_top {
  margin-top: 16px;
  .top-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .title {
      font-weight: bold;
      font-size: 18px;
      color: #343C4A;
    }

    .content-year {
      width: 130px;
    }
  }

  .top-box {
    padding: 24px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    background: #F2F4FA;
    border-radius: 4px;

    .box-name {
      font-weight: bold;
      font-size: 14px;
    }

    .top-box-line {
      width: 1px;
      height: 38px;
      margin: 0 40px;
      background: #D7DBE0;
    }
  }

  .flex-box {
    display: flex;
  }

  .item {
    flex: 1;
    background: #F2F4FA;
    border-radius: 4px;
    opacity: 1;
    padding: 24px 6px;
    margin-right: 16px;
    &:last-child {
      margin-right: 0px;
    }

    .item-name {
      text-align: center;
      font-size: 14px;
      margin-bottom: 16px;
      font-weight: bold;
    }

    .item-left {
      display: flex;
      justify-content: flex-end;
    }

    .item-center {
      padding: 0 40px;
      border-right: 1px solid #D7DBE0;
    }

    .item-right {
      padding-left: 40px;
      display: flex;
      justify-content: flex-start;
    }
  }

  .flex_column-center {
    display: flex;
    flex-direction: column;
    align-items: center;

  }

  .flex-row {
    display: flex;

    .train-name {
      margin-right: 16px;
      font-weight: 400;
      font-size: 12px;
      color: #51627D;
      line-height: 16px;
    }

    .train-num {
      font-weight: 500;
      font-family: "DIN-PRO BOLD";
      font-size: 14px;
      color: #343C4A;
      line-height: 16px;
    }
  }

  .flex-1 {
    flex: 1;
  }

  .num {
    font-family: "DIN-PRO BOLD";
    font-weight: 600;
    font-size: 30px;
    color: #343C4A;
    line-height: 38px;
  }

  .name {

    font-weight: 400;
    font-size: 12px;
    color: #51627D;
    line-height: 16px;
  }

  .mr-16 {
    margin-right: 16px;
  }

  .mt-8 {
    margin-top: 8px;
  }

  .mr-40 {
    margin-right: 60px;
  }
}


@media screen and (max-width: 1450px) { 
  .item {



    .item-center {
      padding: 0 16px !important;
    }

    .item-right {
      padding-left: 16px !important;
    }
  }
}
</style>
